import React from "react";
import StarterKit from "@tiptap/starter-kit";
import { RichTextReadOnly } from "mui-tiptap";

interface RichTextContentProps {
  content: string;
  fontSize?: string;
}

export const RichTextContent: React.FC<RichTextContentProps> = ({
  content,
  fontSize = "14px",
}) => {
  return (
    <RichTextReadOnly
      extensions={[StarterKit]}
      content={content}
      RichTextContentProps={{ fontSize }}
      sx={({ palette }) => ({
        "& .ProseMirror": {
          color: palette.text.primary,
        },
        "&.MuiTiptap-RichTextContent-root.MuiTiptap-RichTextContent-readonly .ProseMirror":
          {
            fontSize,
            "& h3": {
              marginTop: "5px",
              marginBottom: "5px",
              fontSize: "16px",
              lineHeight: 1.8,
            },
          },
      })}
    />
  );
};
